const h1 = (text) => ({ type: "h1", text });
const h2 = (text) => ({ type: "h2", text });
const p = (text) => ({ type: "p", text });
const kicker = (text) => ({ type: "kicker", text });
const ul = (items) => ({ type: "ul", items });
const ol = (items) => ({ type: "ol", items });
const img = (stem, alt, caption) => ({ type: "image", stem, alt, caption: caption || alt });
const note = (text) => ({ type: "note", text });
const warn = (title, text, items) => ({ type: "callout", tone: "warn", title, text, items });
const info = (title, text, items) => ({ type: "callout", tone: "info", title, text, items });
const safe = (title, text, items) => ({ type: "callout", tone: "safe", title, text, items });
const table = (rows) => ({ type: "table", rows });
const link = (href, label) => ({ type: "link", href, label });
const rich = (before, href, label, after) => ({ type: "rich", before, href, label, after });
const sources = (items) => ({ type: "sources", items });
const cta = (href, label) => ({ type: "link", href, label });

function page(title, description, blocks) {
  return { title, description, blocks };
}

module.exports = {
  h1, h2, p, kicker, ul, ol, img, note, warn, info, safe, table, link, rich, sources, cta, page,
};
